import { Alert } from 'antd';
import React from 'react';

import { config } from 'src/apis/api';
import { getPlan, IPlanResponse } from 'src/apis/plans';
import MaDirectPlan from './MaDirect/MaDirectPlan';

export interface IProps {
  companyID: number;
}

interface IState {
  planResponse?: IPlanResponse;
  error?: string;
}

class PlanPage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
    };
  }

  public async componentDidMount() {
    try {
      const planResponse = await getPlan(config.authToken || '', this.props.companyID);
      this.setState({
        planResponse
      });
    } catch (e) {
      this.setState({
        error: 'Could not retrieve plan: ' + e.message,
      })
    }
  }

  public render() {
    const {error, planResponse} = this.state;
    return <>
      <h2>Plan Details for {planResponse ? planResponse.company.companyName : ''} - {this.props.companyID}</h2>
      {
        error && <Alert type={'error'} message={error} />
      }
      {
        planResponse &&
        <MaDirectPlan
            company={planResponse.company}
            currencies={planResponse.currencies}
            includedMailSyncSeats={planResponse.includedMailSyncSeats}
            plan={planResponse.plan}
        />
      }
    </>
  }
}

export default PlanPage;
